<template>
  <div class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#0a0f18] overflow-hidden font-sans">
    <canvas ref="canvasRef" class="absolute inset-0 z-0"></canvas>

    <div class="relative z-10 w-full max-w-sm bg-white p-6 rounded-xl shadow-2xl mx-4 my-8 max-h-[85vh] overflow-y-auto">
      <div class="text-center mb-6">
        <h2 class="text-xl font-extrabold text-gray-800">Global Meridian Cycle</h2>
        <p class="text-xs text-gray-500 mt-1 font-semibold">회원가입</p>
      </div>
      
      <form @submit.prevent="handleSignup" class="space-y-4">
        
        <div class="flex items-center bg-blue-50 p-3 rounded-lg border border-blue-100 mb-2">
          <input type="checkbox" id="isTopNode" v-model="form.isTopNode" class="mr-2 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
          <label for="isTopNode" class="text-xs font-bold text-blue-800 cursor-pointer">최상단(마스터) 계정으로 가입 (후원인 생략)</label>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">국가</label>
          <select v-model="form.country" class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
            <option value="KR">대한민국 (+82)</option>
            <option value="US">미국 (+1)</option>
            <option value="JP">일본 (+81)</option>
            <option value="CN">중국 (+86)</option>
          </select>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">이름</label>
          <input type="text" v-model="form.name" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="실명 입력" />
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">연락처</label>
          <input type="tel" :value="form.phone" @input="formatPhone" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="숫자만 입력" />
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">이메일 (아이디)</label>
          <input type="email" v-model="form.email" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="이메일 입력" />
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">비밀번호</label>
          <div class="relative flex items-center">
            <input :type="showPassword ? 'text' : 'password'" v-model="form.password" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-16" placeholder="비밀번호 입력" />
            <button type="button" @click="showPassword = !showPassword" class="absolute right-0 h-full px-3 text-xs font-bold text-gray-500 hover:text-gray-800 bg-gray-200/50 rounded-r-lg border-l border-gray-200">{{ showPassword ? '숨기기' : '보기' }}</button>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">비밀번호 확인</label>
          <div class="relative flex items-center">
            <input :type="showPasswordConfirm ? 'text' : 'password'" v-model="form.passwordConfirm" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-16" placeholder="비밀번호 재입력" />
            <button type="button" @click="showPasswordConfirm = !showPasswordConfirm" class="absolute right-0 h-full px-3 text-xs font-bold text-gray-500 hover:text-gray-800 bg-gray-200/50 rounded-r-lg border-l border-gray-200">{{ showPasswordConfirm ? '숨기기' : '보기' }}</button>
          </div>
          <p v-if="passwordMismatch" class="text-red-500 text-xs mt-1 font-bold">비밀번호가 일치하지 않습니다.</p>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">소속센터</label>
          <select v-model="form.center" required class="w-full px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
            <option value="서울본사">서울본사</option>
          </select>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">출금 계좌 정보 (선택)</label>
          <div class="flex space-x-2">
            <input type="text" v-model="form.bankName" class="w-1/3 px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="은행명" />
            <input type="text" v-model="form.accountNumber" class="w-1/3 px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="계좌번호" />
            <input type="text" v-model="form.accountHolder" class="w-1/3 px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="예금주" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-gray-700 mb-1">추천인 (선택)</label>
          <div class="flex space-x-2">
            <input type="text" v-model="form.recommenderInput" @keyup.enter.prevent="verifyUser('recommender')" class="flex-1 px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="이름 또는 이메일 검색" />
            <button type="button" @click="verifyUser('recommender')" class="px-4 py-2 bg-gray-200 text-gray-700 font-bold rounded-lg hover:bg-gray-300 text-sm transition-colors shrink-0">
              확인
            </button>
          </div>
          <p v-if="validatedRecommender" class="text-green-600 text-[11px] mt-1 font-bold">
            ✅ {{ validatedRecommender.name }}({{ validatedRecommender.email }}) {{ validatedRecommender.uid }}
          </p>
          <p v-if="recommenderError" class="text-red-500 text-xs mt-1 font-bold">{{ recommenderError }}</p>
        </div>

        <template v-if="!form.isTopNode">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1">후원인</label>
            <div class="flex space-x-2">
              <input type="text" v-model="form.supporterInput" required @keyup.enter.prevent="verifyUser('supporter')" class="flex-1 px-3 py-2 bg-[#f0f4f8] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="이름 또는 이메일 검색" />
              <button type="button" @click="verifyUser('supporter')" class="px-4 py-2 bg-gray-200 text-gray-700 font-bold rounded-lg hover:bg-gray-300 text-sm transition-colors shrink-0">
                확인
              </button>
            </div>
            <p v-if="validatedSupporter" class="text-green-600 text-[11px] mt-1 font-bold">
              ✅ {{ validatedSupporter.name }}({{ validatedSupporter.email }}) {{ validatedSupporter.uid }}
            </p>
            <p v-if="supporterError" class="text-red-500 text-xs mt-1 font-bold">{{ supporterError }}</p>
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1">등록위치</label>
            <div class="flex space-x-4 mt-1">
              <label class="flex items-center text-sm font-bold text-gray-700 cursor-pointer">
                <input type="radio" v-model="form.position" value="LEFT" class="mr-2 border-gray-300 text-blue-600 focus:ring-blue-500" /> 좌 (LEFT)
              </label>
              <label class="flex items-center text-sm font-bold text-gray-700 cursor-pointer">
                <input type="radio" v-model="form.position" value="RIGHT" class="mr-2 border-gray-300 text-blue-600 focus:ring-blue-500" /> 우 (RIGHT)
              </label>
            </div>
          </div>
        </template>

        <p v-if="errorMessage" class="text-red-500 text-xs text-center font-bold">{{ errorMessage }}</p>

        <button type="submit" :disabled="isSubmitting" class="w-full bg-[#1e2532] text-white font-bold py-3 px-4 rounded-lg hover:bg-black transition-colors text-sm mt-4 shadow-md disabled:opacity-50">
          {{ isSubmitting ? '처리 중...' : '가입하기' }}
        </button>
      </form>
      
      <div class="mt-4 text-center">
        <router-link to="/login" class="text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors">로그인 화면으로 돌아가기</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import router from '../router';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp, collection, query, where, getDocs } from 'firebase/firestore';

export default {
  name: 'SignupView',
  setup() {
    const isSubmitting = ref(false);
    const errorMessage = ref('');
    const showPassword = ref(false);
    const showPasswordConfirm = ref(false);
    const canvasRef = ref(null);

    let ctx = null;
    let animationFrameId = null;
    const particles = [];
    const particleCount = 80;

    const form = reactive({
      isTopNode: false,
      country: 'KR',
      name: '',
      phone: '',
      email: '',
      password: '',
      passwordConfirm: '',
      center: '서울본사',
      // 출금 계좌 정보 분리
      bankName: '',
      accountNumber: '',
      accountHolder: '',
      // 추천인, 후원인 입력 필드
      recommenderInput: '',
      supporterInput: '',
      position: 'LEFT'
    });

    // 검증된 회원 정보 저장
    const validatedRecommender = ref(null);
    const validatedSupporter = ref(null);
    const recommenderError = ref('');
    const supporterError = ref('');

    // 입력값이 변경되면 검증 상태 초기화
    watch(() => form.recommenderInput, () => {
      validatedRecommender.value = null;
      recommenderError.value = '';
    });
    watch(() => form.supporterInput, () => {
      validatedSupporter.value = null;
      supporterError.value = '';
    });

    const passwordMismatch = computed(() => {
      return form.passwordConfirm !== '' && form.password !== form.passwordConfirm;
    });

    const formatPhone = (e) => {
      let val = e.target.value.replace(/[^0-9]/g, '');
      if (val.length > 3 && val.length <= 7) {
        val = val.replace(/(\d{3})(\d{1,4})/, '$1-$2');
      } else if (val.length > 7) {
        if (val.startsWith('02')) {
           val = val.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3');
        } else {
           val = val.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
        }
      }
      form.phone = val;
      e.target.value = val;
    };

    // 회원 정보 검증 로직 (이메일 -> 이름 -> UID 순으로 순차 검색)
    const verifyUser = async (type) => {
      const inputValue = type === 'recommender' ? form.recommenderInput.trim() : form.supporterInput.trim();
      
      if (!inputValue) {
        if (type === 'recommender') recommenderError.value = '추천인을 입력해주세요.';
        if (type === 'supporter') supporterError.value = '후원인을 입력해주세요.';
        return;
      }

      const usersRef = collection(db, 'users');
      let snap = null;

      try {
        // 1. 이메일로 검색
        let q = query(usersRef, where('email', '==', inputValue));
        snap = await getDocs(q);

        // 2. 이메일이 없으면 이름으로 검색
        if (snap.empty) {
          q = query(usersRef, where('name', '==', inputValue));
          snap = await getDocs(q);
        }

        // 3. 이름도 없으면 UID로 검색 (URL 파라미터 등)
        if (snap.empty) {
          q = query(usersRef, where('uid', '==', inputValue));
          snap = await getDocs(q);
        }

        if (!snap.empty) {
          const docData = snap.docs[0].data();
          const matchInfo = { name: docData.name, email: docData.email, uid: docData.uid };
          
          if (type === 'recommender') {
            validatedRecommender.value = matchInfo;
            recommenderError.value = '';
          } else {
            validatedSupporter.value = matchInfo;
            supporterError.value = '';
          }
        } else {
          if (type === 'recommender') recommenderError.value = '일치하는 회원을 찾을 수 없습니다.';
          if (type === 'supporter') supporterError.value = '일치하는 회원을 찾을 수 없습니다.';
        }
      } catch (error) {
        console.error("User Verification Error:", error);
      }
    };

    const handleSignup = async () => {
      // 1. 폼 유효성 검사
      if (passwordMismatch.value) {
        errorMessage.value = '비밀번호가 일치하지 않습니다.';
        return;
      }

      if (form.recommenderInput && !validatedRecommender.value) {
        errorMessage.value = '입력된 추천인의 [확인] 버튼을 눌러 검증해주세요.';
        return;
      }

      if (!form.isTopNode && !validatedSupporter.value) {
        errorMessage.value = '후원인의 [확인] 버튼을 눌러 검증해주세요.';
        return;
      }

      try {
        isSubmitting.value = true;
        errorMessage.value = '';

        // 계좌 정보 문자열 병합 (하나라도 입력된 경우에만 포맷팅)
        let mergedAccount = '';
        if (form.bankName || form.accountNumber || form.accountHolder) {
          mergedAccount = `${form.bankName} / ${form.accountNumber} / ${form.accountHolder}`;
        }

        // Auth 생성 전 후원인/추천인 UID 확정
        const supporterValue = form.isTopNode ? 'MASTER' : validatedSupporter.value.uid;
        const recommenderValue = validatedRecommender.value ? validatedRecommender.value.uid : '';
        const positionValue = form.isTopNode ? 'NONE' : form.position;

        // Firebase Auth 가입 진행
        const userCredential = await createUserWithEmailAndPassword(auth, form.email, form.password);
        const user = userCredential.user;

        // Firestore DB 생성
        await setDoc(doc(db, "users", user.uid), {
          uid: user.uid,
          country: form.country,
          name: form.name,
          phone: form.phone,
          email: form.email,
          center: form.center,
          account: mergedAccount, // 병합된 문자열 저장
          recommender: recommenderValue,
          supporter: supporterValue,
          position: positionValue,
          isTopNode: form.isTopNode,
          level: '1L',
          personalPV: 0,
          leftPV: 0,
          rightPV: 0,
          role: 'member',
          createdAt: serverTimestamp()
        });

        alert('회원가입이 완료되었습니다.');
        router.push('/login');
      } catch (error) {
        console.error("Signup Error:", error);
        if (error.code === 'auth/email-already-in-use') {
          errorMessage.value = '이미 사용 중인 이메일입니다.';
        } else {
          errorMessage.value = '회원가입 처리 중 오류가 발생했습니다.';
        }
      } finally {
        isSubmitting.value = false;
      }
    };

    // 캔버스 애니메이션 로직
    const initCanvas = () => {
      if (!canvasRef.value) return;
      ctx = canvasRef.value.getContext('2d');
      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      
      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * canvasRef.value.width,
          y: Math.random() * canvasRef.value.height,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6,
          radius: Math.random() * 1.5 + 0.5
        });
      }
      animate();
    };

    const resizeCanvas = () => {
      if (!canvasRef.value) return;
      canvasRef.value.width = window.innerWidth;
      canvasRef.value.height = window.innerHeight;
    };

    const animate = () => {
      if (!canvasRef.value || !ctx) return;
      ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
      
      for (let i = 0; i < particles.length; i++) {
        let p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        
        if (p.x < 0 || p.x > canvasRef.value.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvasRef.value.height) p.vy *= -1;
        
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 204, 0, 0.7)';
        ctx.fill();
        
        for (let j = i + 1; j < particles.length; j++) {
          let p2 = particles[j];
          let dx = p.x - p2.x;
          let dy = p.y - p2.y;
          let dist = Math.sqrt(dx * dx + dy * dy);
          
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = `rgba(255, 204, 0, ${1 - dist / 120})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    onMounted(() => {
      initCanvas();
      // URL 파라미터에서 추천인 UID 추출
      const urlParams = new URLSearchParams(window.location.search);
      const refUid = urlParams.get('ref');
      if (refUid) {
        form.recommenderInput = refUid; // 추천인 필드에 자동 입력
        verifyUser('recommender'); // 자동으로 검증 함수 실행
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeCanvas);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    });

    return {
      form,
      showPassword,
      showPasswordConfirm,
      passwordMismatch,
      errorMessage,
      isSubmitting,
      validatedRecommender,
      validatedSupporter,
      recommenderError,
      supporterError,
      formatPhone,
      verifyUser,
      handleSignup,
      canvasRef
    };
  }
}
</script>